var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  font-weight: ", ";\n  color: ", ";\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('styled-components'), require('@rtm-ui/theme'), require('@rtm-ui/tracker'), require('@rtm-ui/typography')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'styled-components', '@rtm-ui/theme', '@rtm-ui/tracker', '@rtm-ui/typography'], factory) : (global = global || self, factory(global.a = {}, global.React, global.PropTypes, global.styled, global.RtmUiTheme, global.RtmUiTracker, global.RtmUiTypography));
})(this, function (exports, React, PropTypes, styled, theme, tracker, typography) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var TextStyle = styled(typography.Text)(_templateObject(), function (props) {
    return props.weight ? theme.getWeight(props.weight) : 400;
  }, function (props) {
    return theme.getColor(props.color || 'link', props.theme);
  }, function (props) {
    return theme.getColor('linkHover', props.theme);
  });

  var A = function A(_ref) {
    var track = _ref.track,
        _onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ["track", "onClick"]);

    var _tracker$useTracker = tracker.useTracker(),
        ref = _tracker$useTracker.ref,
        trackEvent = _tracker$useTracker.trackEvent;

    return (
      /*#__PURE__*/
      React.createElement(TextStyle, _extends({
        ref: ref,
        onClick: function onClick(e) {
          return trackEvent(e, track, _onClick);
        }
      }, props))
    );
  };

  A.defaultProps = {
    tag: 'a'
  };
  A.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func
  };
  exports.A = A;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});